import * as Types from '../../api/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type SetUserAttributesMutationVariables = Types.Exact<{
  data: Types.AttributesInput;
}>;


export type SetUserAttributesMutation = { __typename?: 'Mutation', SetUserAttributes?: { __typename?: 'Visitor', name?: string | null, email?: string | null, image?: string | null, attributes?: Array<{ __typename?: 'VisitorAttributeCategory', name: string, attributes?: Array<{ __typename?: 'VisitorAttribute', name: string, value: string, type: Types.VisitorAttributeType } | null> | null } | null> | null } | null };


export const SetUserAttributesDocument = gql`
    mutation SetUserAttributes($data: AttributesInput!) {
  SetUserAttributes(data: $data) {
    name
    email
    image
    attributes {
      name
      attributes {
        name
        value
        type
      }
    }
  }
}
    `;
export type SetUserAttributesMutationFn = ApolloReactCommon.MutationFunction<SetUserAttributesMutation, SetUserAttributesMutationVariables>;

/**
 * __useSetUserAttributesMutation__
 *
 * To run a mutation, you first call `useSetUserAttributesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserAttributesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserAttributesMutation, { data, loading, error }] = useSetUserAttributesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSetUserAttributesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetUserAttributesMutation, SetUserAttributesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetUserAttributesMutation, SetUserAttributesMutationVariables>(SetUserAttributesDocument, options);
      }
export type SetUserAttributesMutationHookResult = ReturnType<typeof useSetUserAttributesMutation>;
export type SetUserAttributesMutationResult = ApolloReactCommon.MutationResult<SetUserAttributesMutation>;
export type SetUserAttributesMutationOptions = ApolloReactCommon.BaseMutationOptions<SetUserAttributesMutation, SetUserAttributesMutationVariables>;